// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.elements-table > * {
    padding: unset;
    margin: unset;
}

table.elements-table {
    border-spacing: 0;
    font-size: 1.3rem;
    position: relative;
}

table.elements-table tbody tr:hover td {
    background-color: whitesmoke !important;
}
table.elements-table th, table.elements-table td {
    padding: 0.75rem;
}
table.elements-table th:last-child, table.elements-table td:last-child {
    padding-right: 40px;
}

table.elements-table thead tr {
    height: 80px;
}
table.elements-table th {
    cursor: pointer;
}
table.elements-table td {
    outline: 1px solid #e9ecef;
    border:none;
    vertical-align: middle;
    font-size: 1.3rem;
}

table.elements-table td input{
    font-size: 1.5rem;
}

table.elements-table .table-header {
    height: 65px;
    vertical-align: bottom;
    display: table-header-group;
    background-color: var(--gray);
}
table.elements-table .module-header {
    transform: rotate(-45deg) translateX(25%) translateY(-25%);
    width: 30px;
}
table.elements-table .module-header div {
    width: 150px;
    font-size: 1rem;
    line-height: 0.95rem;
}

[data-tooltip]:hover:after {
    opacity: 1;
    visibility: visible;
}
[data-tooltip]:after {
    content: attr(data-tooltip);
    background-color: white;
    color: black;
    font-size: 1rem;
    position: absolute;
    padding: 7px 7px 7px 7px;
    bottom: 1.6em;
    left: 100%;
    white-space: nowrap;
    opacity: 0;
    border: 1px solid #111111;
    z-index: 100;
    visibility: hidden;
}
[data-tooltip] {
    position: relative;
}

.user-initials {
    position: absolute;
    top: 0;
    right: -0.5rem;
    color: orange;
    font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/lib/components/ElementsTable.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;IACI,0DAA0D;IAC1D,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,aAAa;IACb,eAAe;AACnB","sourcesContent":["table.elements-table > * {\r\n    padding: unset;\r\n    margin: unset;\r\n}\r\n\r\ntable.elements-table {\r\n    border-spacing: 0;\r\n    font-size: 1.3rem;\r\n    position: relative;\r\n}\r\n\r\ntable.elements-table tbody tr:hover td {\r\n    background-color: whitesmoke !important;\r\n}\r\ntable.elements-table th, table.elements-table td {\r\n    padding: 0.75rem;\r\n}\r\ntable.elements-table th:last-child, table.elements-table td:last-child {\r\n    padding-right: 40px;\r\n}\r\n\r\ntable.elements-table thead tr {\r\n    height: 80px;\r\n}\r\ntable.elements-table th {\r\n    cursor: pointer;\r\n}\r\ntable.elements-table td {\r\n    outline: 1px solid #e9ecef;\r\n    border:none;\r\n    vertical-align: middle;\r\n    font-size: 1.3rem;\r\n}\r\n\r\ntable.elements-table td input{\r\n    font-size: 1.5rem;\r\n}\r\n\r\ntable.elements-table .table-header {\r\n    height: 65px;\r\n    vertical-align: bottom;\r\n    display: table-header-group;\r\n    background-color: var(--gray);\r\n}\r\ntable.elements-table .module-header {\r\n    transform: rotate(-45deg) translateX(25%) translateY(-25%);\r\n    width: 30px;\r\n}\r\ntable.elements-table .module-header div {\r\n    width: 150px;\r\n    font-size: 1rem;\r\n    line-height: 0.95rem;\r\n}\r\n\r\n[data-tooltip]:hover:after {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n[data-tooltip]:after {\r\n    content: attr(data-tooltip);\r\n    background-color: white;\r\n    color: black;\r\n    font-size: 1rem;\r\n    position: absolute;\r\n    padding: 7px 7px 7px 7px;\r\n    bottom: 1.6em;\r\n    left: 100%;\r\n    white-space: nowrap;\r\n    opacity: 0;\r\n    border: 1px solid #111111;\r\n    z-index: 100;\r\n    visibility: hidden;\r\n}\r\n[data-tooltip] {\r\n    position: relative;\r\n}\r\n\r\n.user-initials {\r\n    position: absolute;\r\n    top: 0;\r\n    right: -0.5rem;\r\n    color: orange;\r\n    font-size: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
